import React, { useState } from "react";

import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";
import DeleteIcon from "@material-ui/icons/Delete";
import api from "../../utils/api";

const DeleteCellRenderer = (props) => {
  const APIBASE_URL = process.env.REACT_APP_APIBASE_URL;
  const [open, setOpen] = useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const deleteShipment = async () => {
    setOpen(false);

    try {
      const resp = await api.post(`${APIBASE_URL}/deleteByShipmentIds`, {
        ShipmentIds: [props.value],
      });

      console.log("delete shipment response", resp);

      if (resp.status === 200) {
        props.api?.applyTransaction?.({ remove: [props.data] });
        props.handleDeleteSuccess?.();
        await props.update?.();
      }
    } catch (error) {
      console.error("Failed to delete shipment", error);
    }
  };

  return (
    <div>
      <Button onClick={handleClickOpen}>
        <DeleteIcon></DeleteIcon>
      </Button>

      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">
          {"Please confirm Delete action"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure to delete this shipment? This action can not be undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleClose} color="primary">
            Cancel
          </Button>
          <Button onClick={deleteShipment} color="primary" autoFocus>
            Proceed
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default DeleteCellRenderer;
